import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { ProductService, SubscriptionService } from '@suvo-bi-users';
import { SnackBarService } from '@suvo/frontend-framework/SUVO-BI-CLIENT-LIB/projects/suvo-bi-client-lib/src/public-api';
import { Observable } from 'rxjs';
import { catchError, map } from 'rxjs/operators';

@Injectable()
export class SubscriptionInterceptor implements HttpInterceptor {
  constructor(
    private productService: ProductService,
    private router: Router,
    private snackBarService: SnackBarService,
  ) {}

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    return next.handle(req).pipe(
      catchError(async (error, ev) => {
        console.log(error);

        if (error?.error?.message == 'Subscription access is not allowed') {
          await this.productService.fetchAllOwned();

          let ownedProducts = this.productService.ownedProductsList.getValue();

          if (!ownedProducts || ownedProducts.length == 0) {
            this.router.navigate(['/upgrade']);
          }
        } else if (
          error?.error?.message ==
          'Unable to create a free subscription as it was disabled or already used'
        ) {
          this.snackBarService.open('Unable to create a subscription, please contact support.');
        }

        throw error;
      }),
    );
  }
}
